// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__10fwL","title":"ClientReferral_title__3oROF","itemText":"ClientReferral_itemText__CYvEk"};